import { HTTP_AP_AdvisorUserPermissionSettings } from '@api-new/userservice';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PROFILE_NAME_PLACEHOLDER } from '@shared/constants/constants';
import { PlatformTypeEnum } from '@shared/enums/platform-type.enum';
import { PlatformStateModel } from '@shared/models/platform-state.model';

export const selectPlatformState = createFeatureSelector<PlatformStateModel>('platform');

export const selectPlatformType = createSelector(selectPlatformState, (state: PlatformStateModel): PlatformTypeEnum => state.platformType);

export const selectPlatformDataLoaded = createSelector(selectPlatformState, (state: PlatformStateModel): boolean => state.loaded);

export const selectPlatformUserDisplayName = createSelector(
  selectPlatformState,
  (state: PlatformStateModel): string => state.adviserUser?.displayName ?? PROFILE_NAME_PLACEHOLDER,
);

export const selectPlatformCompanyLogo = createSelector(selectPlatformState, (state: PlatformStateModel): string => state.company?.logo);

export const selectPlatformNetworkId = createSelector(selectPlatformState, (state: PlatformStateModel): string => state.network?.id);

export const selectPlatformUserPermissions = createSelector(
  selectPlatformState,
  (state: PlatformStateModel): HTTP_AP_AdvisorUserPermissionSettings => state.adviserUser?.advisorUserPermissionSettings,
);

export const selectPlatformUserId = createSelector(selectPlatformState, (state: PlatformStateModel): string => state.adviserUser?.id);
